import React, { useState, useEffect } from "react";
import AdmissionPolicy from "./AdmissionPolicy";
import { useMobile } from "../hooks/custom/useMobile";
import useTab from "../hooks/custom/useTab";
import FinancialAidPolicy from "./FinancialAidsPolicy";
import { useTabs } from "../hooks/lib/useTabs";
import {
  IAdmissionPolicyData,
  IScholarshipsAndFinancialData,
} from "../exports/interfaces";

const PoliciesDrawer = ({
  admissionPolicy,
  scholarshipsAndFinancial,
}: {
  admissionPolicy: IAdmissionPolicyData[];
  scholarshipsAndFinancial: IScholarshipsAndFinancialData[];
}) => {
  const [activeTab, setActiveTab] = useState("admission");
  const mobile = useMobile();
  const tab = useTab();

  useTabs();

  useEffect(() => {
    const handleRemoteToggle = (e: any) => {
      const targetTab = e.detail;
      setActiveTab(targetTab);
    };

    window.addEventListener("SET_POLICY_TAB", handleRemoteToggle);

    return () => {
      window.removeEventListener("SET_POLICY_TAB", handleRemoteToggle);
    };
  }, []);

  return (
    <div
      className={`offcanvas ${
        mobile || tab ? "offcanvas-bottom" : "offcanvas-end"
      }`}
      tabIndex={-1}
      id="admissionOffcanvas"
      data-bs-backdrop="true"
      data-bs-scroll="false"
      style={{
        width: mobile || tab ? "100%" : "900px",
        height: mobile || tab ? "75dvh" : "100dvh",
      }}
    >
      <div className="offcanvas-body">
        <button
          type="button"
          className="btn-close td_mb_20"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        />

        <div className="td_tabs td_style_1 td_mb_30">
          <ul className="td_tab_links td_style_2 td_type_2 td_mp_0 td_medium td_fs_16 td_heading_color">
            <li className={activeTab === "admission" ? "active" : ""}>
              <a href="#td_tab_1" onClick={() => setActiveTab("admission")}>
                Admission Policy
              </a>
            </li>
            <li className={activeTab === "scholarship" ? "active" : ""}>
              <a href="#td_tab_2" onClick={() => setActiveTab("scholarship")}>
                Scholarships and Financial Aid
              </a>
            </li>
          </ul>

          <div className="td_tab_body td_fs_18">
            <div
              className={`td_tab ${activeTab === "admission" ? "active" : ""}`}
              id="td_tab_1"
              style={{ display: activeTab === "admission" ? "block" : "none" }}
            >
              <AdmissionPolicy admissionPolicy={admissionPolicy} />
            </div>
            <div
              className={`td_tab ${activeTab === "scholarship" ? "active" : ""}`}
              id="td_tab_2"
              style={{
                display: activeTab === "scholarship" ? "block" : "none",
              }}
            >
              <FinancialAidPolicy scholarshipsAndFinancial={scholarshipsAndFinancial}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliciesDrawer;
